import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { rest } from '@/lib/hono-client';
import type { Todo } from '@app/server/src/features/todos/todos.schema';

export const todosQueryOptions = {
  queryKey: ['todos'],
  queryFn: async (): Promise<Todo[]> => {
    const res = await rest.api.todos.$get();

    if (!res.ok) {
      const body = await res.json();
      console.debug('Fetch todos error:', res.status, body);
      throw new Error('Failed to fetch todos');
    }

    const body = await res.json();
    console.debug('Fetch todos success:', body);
    return body;
  },
};

export function useTodosQuery() {
  return useQuery(todosQueryOptions);
}

export function useCreateTodoMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (text: string) => {
      console.debug('Creating todo with text:', text);
      const res = await rest.api.todos.$post({ json: { text } });

      if (!res.ok) {
        const body = await res.json();
        console.debug('Create todo error:', res.status, body);
        throw new Error('Failed to create todo');
      }

      const body = await res.json();
      console.debug('Create todo success:', body);
      return body;
    },

    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['todos'] });
      console.debug('Todos query invalidated after creating todo');
    },
  });
}
